import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { actions, getters } from "Modules/MultiAddColumnModal/model";
import {
  getIsStandardField,
  getMaxLengthFormatted,
  getShowMaxLength,
  hasFormErrors
} from "../selectors";
import Loading from "./Loading";
import StandardField from "./StandardField";
import css from "./style.scss";

import { withRouter } from "react-router";

import { orgId as getOrgId } from "redux/modules/organization/selectors";
import { eventId as getEventId } from "redux/modules/event/selectors";
import getColumnTypes from "components/Event/Settings/Module/utils/get-column-types";
import FormContent from "./FormContent";
import {
  BigOutlineButton,
  Div,
  DownFilledIcon,
  Text2,
  Text3,
  UpFilledIcon
} from "components/Base";

const decorate = R.compose(
  withRouter,
  connect(
    (state, props) => {
      const opts = {
        orgId: props.params.eventId
          ? undefined
          : props.params.orgId || getOrgId(state),
        eventId: props.params.orgId
          ? undefined
          : props.params.eventId || getEventId(state)
      };

      return {
        ...opts,
        loading: getters.loading(state, props),
        forms: getters.forms(state, props),
        expandedForms: getters.expandedForms(state, props),
        isStandardField: getIsStandardField(state, props),
        fieldTypes: getColumnTypes(props.moduleId, opts.orgId, opts.eventId),
        fieldGroups: getters.fieldGroups(state, props),
        maxLength: getMaxLengthFormatted(state, props),
        showMaxLength: getShowMaxLength(state, props),
        hasErrors: hasFormErrors(state, props)
      };
    },
    {
      init: actions.init,
      addForm: actions.addForm,
      toggleFormExpansion: actions.toggleFormExpansion,
      handleSave: actions.handleSave
    }
  ),
  CSSModules(css)
);

const Layout = props => {
  const {
    init,
    loading,
    isStandardField,
    fieldId,
    forms,
    expandedForms,
    addForm,
    toggleFormExpansion,
    onSave,
    handleSave,
    hideModal,
    isInductionFormField = false
  } = props;

  useEffect(() => {
    init({
      ...props
    });
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (isStandardField) {
    return <StandardField />;
  }

  const getDropdownIcon = index => {
    return expandedForms.includes(index) ? (
      <UpFilledIcon size={24} color="neutral9" />
    ) : (
      <DownFilledIcon size={24} color="neutral9" />
    );
  };

  const isEditMode = fieldId !== undefined;

  return (
    <div styleName="modalWrapper">
      <div styleName="modal" onMouseDown={e => e.stopPropagation()}>
        <div styleName="modalHeader">
          <div styleName="modalTitle">{isEditMode ? "Edit" : "Add"} Field</div>
        </div>
        <div styleName="modalBody">
          {forms.map((form, index) => (
            <div key={form.id} styleName="accordionItem">
              {!isEditMode && (
                <Div
                  key="accordionHeader"
                  display="row.space-between.center"
                  bg="white"
                  p={1.5}
                  onClick={() => toggleFormExpansion({ index })}
                >
                  <Text2 bold>{`Field ${index + 1}`}</Text2>
                  {getDropdownIcon(index)}
                </Div>
              )}
              {expandedForms.includes(index) && (
                <div styleName="accordionContent">
                  <FormContent {...props} formIndex={index} />
                </div>
              )}
            </div>
          ))}
        </div>
        <Div styleName="modalFooter">
          {!isEditMode && (
            <BigOutlineButton
              onClick={e => {
                e.stopPropagation();
                addForm();
              }}
              width={1}
              height={50}
              zIndex={1000}
            >
              <Text3 fw={3}>Add Another Field</Text3>
            </BigOutlineButton>
          )}
          <div styleName="actionsWrapper">
            <button
              disabled={props.hasErrors}
              onClick={() =>
                !props.hasErrors && handleSave({ onSave, isInductionFormField })
              }
              styleName={props.hasErrors ? "save-disabled" : "actionSave"}
            >
              Save
            </button>
            <button onClick={hideModal} styleName="actionCancel">
              Cancel
            </button>
          </div>
        </Div>
      </div>
    </div>
  );
};

export default decorate(Layout);
